import { render, staticRenderFns } from "./LmCodificatorBuilderListbuilder.vue?vue&type=template&id=2229cfba"
import script from "./LmCodificatorBuilderListbuilder.vue?vue&type=script&lang=js"
export * from "./LmCodificatorBuilderListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports